import { Avatar, Button, Checkbox, FormControl, FormControlLabel, Grid, IconButton, Input, InputLabel, Link, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, ListSubheader, MenuItem, Paper, Select, TextField, Typography } from "@mui/material";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import APIManager from '../../lib/apiManager';
import EditorTest from "../EditorTest";
import WYSIWYGEditor from "../WYSIWYGEditor";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { Stack } from '@mui/material';
import { Add, Cancel, CancelOutlined, Check, CheckCircle, CheckCircleOutline, Delete } from "@mui/icons-material";
import { sistema } from '../../model/Sistema';
import EmpresaCard from "./components/EmpresaCard";
import UsuarioCard from "./components/UsuarioCard";
import OnboardingCard from "./components/OnboardingCard";

const PrestadorDeBeneficios = ({setBotonera}) => {

  const [prestador, setPrestador] = useState(null);
  const [active, setActive] = useState(false);

  const [editando, setEditando] = useState(false);
  const [agregando, setAgregando] = useState(false);

  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [logo, setLogo] = useState(null);
  const [staff, setStaff] = useState([]);

  const [staffEmail, setStaffEmail] = useState('');
  const [staffNombres, setStaffNombres] = useState('');
  const [staffApellidos, setStaffApellidos] = useState('');

  const [emailOk, setEmailOk] = useState(false);
  const [staffEmailError, setStaffEmailError] = useState('');

  const [habilitadoParaGuardar, setHabilitadoParaGuardar] = useState(false);

  const [ready, setReady] = useState(false);

  let { prestadorId } = useParams();

  const nuevoPrestador = {
    id: null,
    nombre: '',
    descripcion: '',
    logo: null,
    active: false,
    staff: [],
  };

  const botonera = [
    { title: 'Volver', label: 'Volver', variant: 'outlined', onClick: () => { navigate(-1); } },
    { title: 'Editar', label: 'Editar', variant: (editando ? 'outlined' : 'contained'), visible: !editando, onClick: () => { setEditando(!editando); } },
    { title: 'Cancelar', label: 'Cancelar', variant: 'outlined', visible: editando, onClick: () => { handleCancelar(); } },
    { title: 'Guardar', label: 'Guardar', variant: 'contained', visible: editando, disabled: !habilitadoParaGuardar, onClick: () => { handleGuardar(); } },
  ];

  const navigate = useNavigate();

  const editarCliente = () => {
    setEditando(!editando);
  }

  const prestadorActualizado = () => {
    const prestadorActualizado = { ...prestador };
    prestadorActualizado.active = active;
    prestadorActualizado.nombre = nombre;
    prestadorActualizado.descripcion = descripcion;
    prestadorActualizado.logo = logo;
    prestadorActualizado.staff = staff;

    return prestadorActualizado;

  }

  const guardarPrestador = () => {
    const prestadorAEnviar = prestadorActualizado();

    // APIManager.sendRequest('post', 'clientes', 'modificarCliente', {cliente: cliente}, (response) => {
    APIManager.sendRequest('post', 'beneficios', 'modificarPrestador', { prestador: prestadorAEnviar }, (response) => {
      if (response.success) {
        setEditando(false); // Se guardó y ya no estamos editando
        setPrestador(response.data.prestador);
        if (prestadorId == 'nuevo') {
          prestadorId = response.data.prestador.id;
        }
        actualizarPrestador();
      }
    });

  }

  const guardarStaff = (staffModificado, callback) => {
    APIManager.sendRequest('post', 'beneficios', 'modificarStaffDePrestador', {prestador: prestador, staff: staffModificado}, response => {
      if (response.success) {
        callback(response);
      }
    });

  }

  const limpiarStaff = () => {
    setStaffEmail('');
    setStaffNombres('');
    setStaffApellidos('');
  }

  const handleActive = (event) => {
    setActive(event.target.checked);
    setHabilitadoParaGuardar(true);
  }

  const handleNombre = (event) => {
    setNombre(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handleDescripcion = (event) => {
    setDescripcion(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handleLogo = (event) => {
    setLogo(event.target.value);
    setHabilitadoParaGuardar(true);
  }

  const handleStaffEmail = (event) => {
    setStaffEmail(event.target.value);
  }

  const handleStaffNombres = (event) => {
    setStaffNombres(event.target.value);
  }

  const handleStaffApellidos = (event) => {
    setStaffApellidos(event.target.value);
  }

  const handleCancelarAgregando = () => {
    setAgregando(false);
    limpiarStaff();
  }

  const checkStaffEmail = () => {
    if (staff.find(item => item.email == staffEmail)) {
      setStaffEmailError('Ya hay staff con ese email');
      setEmailOk(true);
      return false;
    } else {
      setStaffEmailError('');
      if (staffEmail == '') {
        setEmailOk(true);
      } else {
        setEmailOk(false);
      }
      return true;
    }
  }

  const handleAgregarStaff = () => {
    // Verificamos que el staffEmail nuevo no exista entre el staff actual
    if (checkStaffEmail()) {
      const nuevoStaff = { id: null, nombres: staffNombres, apellidos: staffApellidos, email: staffEmail };
      guardarStaff([...staff, nuevoStaff], () => {
        handleCancelarAgregando();
        actualizarPrestador();
      });
    }
  }

  const handleQuitarStaff = (staffAQuitar) => {
    console.log('handleQuitarStaff', staffAQuitar);
    guardarStaff(staff.filter(item => item.id !== staffAQuitar.id), () => {
      handleCancelarAgregando();
      actualizarPrestador();
    });

  }

  const handleGuardar = (event) => {
    guardarPrestador();
  }

  const handleCancelar = (event) => {
    setEditando(false);
    if (prestadorId == 'nuevo') {
      navigate(-1);
    } else {
      actualizarPrestador();
    }
  }

  const actualizarPrestador = () => {
    if (prestadorId === "nuevo") {
      // Es un prestador nuevo
      const prestadorActual = Object.assign({}, nuevoPrestador);
      setPrestador(prestadorActual);
      setEditando(true);
    } else {
      // Vino prestadorId, obtenemos el prestador
      APIManager.sendRequest('post', 'beneficios', 'getPrestador', {prestadorID: prestadorId, conStaff: true}, (response) => {
        if (response.success) {
          setPrestador(response.data.prestador);
        }
      })
    }

  }

  useEffect(() => {

    if (!!prestadorId) {
      actualizarPrestador();
    }


  }, [prestadorId]);

  useEffect(() => {
    if (!!prestador) {
      sistema.actual.prestador = prestador;
      setNombre(prestador.nombre);
      setDescripcion(prestador.descripcion);
      setStaff(prestador.staff);
      setLogo(prestador.logo);
      setActive(prestador.active);
    }
  }, [prestador]);

  useEffect(() => {
    checkStaffEmail();
  }, [staffEmail]);

  useEffect(() => {
    setBotonera(botonera);
  }, [habilitadoParaGuardar, nombre, active, editando, descripcion, logo, staff]);

  return (
    <Paper sx={{ padding: '14px' }}>
      {!!prestador
        ? <Grid container spacing={2}>
          <Grid item sm={4}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="nombre-label" >Nombre</InputLabel>
              <Input
                disabled={!editando}
                labelId="nombre-label"
                id="nombre-input"
                value={nombre}
                onChange={handleNombre}
                required
              >
              </Input>
            </FormControl>
          </Grid>
          <Grid item sm={2} >
            <FormControlLabel label="Activo" control={
              <Checkbox disabled={!editando} checked={active} onChange={handleActive} />
            } />
          </Grid>
          {/* <Grid item sm={2} >
            <FormControlLabel label="Logo" control={
              <Avatar />
            } />
          </Grid> */}
          <Grid item sm={10}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="descripcion-label" >Descripción</InputLabel>
              <Input
                disabled={!editando}
                labelId="descripcion-label"
                id="descripcion-input"
                value={descripcion}
                onChange={handleDescripcion}
                required
              >
              </Input>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography>Usuarios</Typography>
            <List>
              <ListItem key="add">
                {!!agregando
                  ? <Grid container item xs={12} spacing={2}>
                    <Grid item xs={12}><TextField fullWidth label="Email" value={staffEmail} onChange={handleStaffEmail} error={!!staffEmailError} helperText={staffEmailError} /></Grid>
                    <Grid item xs={6}><TextField fullWidth label="Nombres" value={staffNombres} onChange={handleStaffNombres} /></Grid>
                    <Grid item xs={6}><TextField fullWidth label="Apellidos" value={staffApellidos} onChange={handleStaffApellidos} /></Grid>
                    <Grid item xs={12} alignItems="center" justifyContent="flex-end" display="flex">
                      <IconButton disabled={!!emailOk} onClick={handleAgregarStaff} ><CheckCircleOutline color={!!emailOk ? "disabled" : "success"} sx={{ width: '40px', height: '40px'}} /></IconButton>
                      <IconButton onClick={handleCancelarAgregando} ><CancelOutlined color="error" sx={{ width: '40px', height: '40px'}} /></IconButton>
                    </Grid>
                  </Grid>
                  : <ListItemButton disabled={!editando} onClick={() => setAgregando(true)}>
                    <ListItemIcon><Add color="primary" /></ListItemIcon>
                    <ListItemText>Agregar usuario</ListItemText>
                  </ListItemButton>
                }
              </ListItem>
              {!!staff && (staff.length > 0) && staff.map(item => <ListItem disabled={!editando} key={item.id}>
                <ListItemButton disabled={!editando} title={item.descripcion} onClick={() => handleQuitarStaff(item)}>
                  <ListItemIcon><Delete /></ListItemIcon>
                  <ListItemText sx={{width: '100%'}}>{item.descripcion}</ListItemText>
                </ListItemButton>
              </ListItem>)}
            </List>
          </Grid>
        </Grid>
        : <>{ 'No hay datos del prestador' }</>
      }
    </Paper>
  )
}

export default PrestadorDeBeneficios;